import { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "./selectFieldComponent.module.scss";

const SelectFieldComponent = ({
  optionsList,
  firstOption,
  onSelectChange,
  classes,
}) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [firstOption]);

  const handleSelectChange = async (event) => {
    setIsLoading(true);
    const value = event.target.value;
    onSelectChange(value);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center w-100">
        <ClipLoader color="#000" size="22px" />
      </div>
    );
  }

  return (
    <div className="w-100">
      {isLoading && (
        <div className="d-flex justify-content-center w-100">
          <ClipLoader color="#000" size="22px" />
        </div>
      )}
      <select
        key={firstOption}
        className={`${classes} ${styles.select}`}
        onChange={handleSelectChange}
        defaultValue={firstOption}
      >
        <option value="" hidden className="text-black">
          {firstOption}
        </option>
        {optionsList.map((dt, index) => (
          // console.log(dt)
          <option value={dt?.value} key={index}>
            {dt?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectFieldComponent;
